const BreakPoint = 768;
let swiperProductImageThumbnail;
let swiperProductImage;
let swiperProductImageSp;

window.addEventListener(
  'load',
  () => {
    if (BreakPoint < window.innerWidth) {
      createProductImageSwiper();
    } else {
      createProductImageSwiperSp();
    }
  },
  false
);

window.addEventListener(
  'resize',
  () => {
    if (BreakPoint < window.innerWidth) {
      swiperProductImageSp.destroy(false, true);
      createProductImageSwiper();
    } else if (BreakPoint >= window.innerWidth) {
      swiperProductImage.destroy(false, true);
      swiperProductImageThumbnail.destroy(false, true);
      createProductImageSwiperSp();
    }
  },
  false
);

const createProductImageSwiper = () => {
  const slideLength = document.querySelectorAll('.swiper-product-img-slide').length;

  if (slideLength > 1) {
    swiperProductImageThumbnail = new Swiper('.swiper-product-thumbnail', {
      slidesPerView: slideLength,
      spaceBetween: 6,
      freeMode: true,
      grabCursor: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      wrapperClass: 'swiper-product-thumbnail-wrapper',
      slideClass: 'swiper-product-thumbnail-slide',
      threshold: 3,
    });

    swiperProductImage = new Swiper('.swiper-product-img', {
      speed: 300,
      slidesPerView: 1,
      loop: true,
      loopAdditionalSlides: 0,
      centeredSlides: false,
      grabCursor: true,
      slideClass: 'swiper-product-img-slide',
      wrapperClass: 'swiper-product-img-wrapper',
      thumbs: {
        swiper: swiperProductImageThumbnail,
      },
      navigation: false,
    });
  }
};

const createProductImageSwiperSp = () => {
  const slideLength = document.querySelectorAll('.swiper-product-img-slide').length;

  if (slideLength > 1) {
    swiperProductImageSp = new Swiper('.swiper-product-img', {
      speed: 300,
      slidesPerView: 1,
      loop: true,
      loopAdditionalSlides: 0,
      centeredSlides: false,
      grabCursor: true,
      slideClass: 'swiper-product-img-slide',
      wrapperClass: 'swiper-product-img-wrapper',
      navigation: false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }
};
